import { render, staticRenderFns } from "./BottomBanner.vue?vue&type=template&id=66360481&scoped=true&"
import script from "./BottomBanner.vue?vue&type=script&lang=js&"
export * from "./BottomBanner.vue?vue&type=script&lang=js&"
import style0 from "./BottomBanner.vue?vue&type=style&index=0&id=66360481&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66360481",
  null
  
)

export default component.exports